import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { axiosInstance } from "../../config/axios";

export interface IMerchantAddRequest {
  memberId?: number;
  merchantType: number;
  merchantStatusType: string;
  merchantName: string;
  parentMerchantId?: number;
  tradeName: string;
  tradeRegistrationNumber: string;
  commissionProfileCode: string;
  webSite: string;
  taxNumber: string;
  taxOfficeCode: string;
  taxOfficeName: string;
  citizenshipNumber?: string;
  mcc: string;
  originalMcc?: string;
  foundationDate: string;
  openingDate?: string;
  aggreementDate?: string;
  closedDate?: null | string;
  phoneNumber: string;
  description: string;
  mobilePos: boolean;
  vpos: boolean;
  pos: boolean;
  annulmentCode: string;
  status: string;
  annulmentStaff?: string;
  annulmentCodeDesc?: string;
  passiveReason?: string;
  paymentDescriptionPlaceholder?: string;
  integrationStatus: boolean;
  integratorId: number;
  integratorUid: string;
  integratorPwd: string;
  integratorGbAlias: string;
  erpCustomerCode: string;
  paymentBlockedDay?: number | null;
  blockedDay?: number | null;
  addressLine1?: string;
  addressLine2?: string;
  cityId?: number;
  districtId?: number;
  mobilePhoneNumber?: string;
  zipCode?: string;
  emailAddress1?: string;
  emailAddress2?: string;
  faxNumber?: string;
  addressPhoneNumber?: string;
  isPayoutBlocked?: boolean;
  payoutBlockReason?: string;
  VPosIntegrationStatus?: number;
  merchantStatusDescription?: string;
  isCallbackUrlControl?: boolean;
  callbackUrl?: string;
  employeeCount?: number;
  estimatedGiro?: number;
  isUsageFee?: boolean;
}

export type IMerchantAddResponse = BaseResponse<{
  merchantId: number;
}>

async function merchantAdd(
  data: IMerchantAddRequest
): Promise<IMerchantAddResponse> {
  try {
    return (await axiosInstance.post("/Merchant/add", { memberId: 0, ...data }))
      .data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useMerchantAdd() {
  return useMutation<any, Error, IMerchantAddRequest>(
    (variables) => merchantAdd(variables)
  );
}



